import { Component } from '@angular/core';

@Component({
  selector: 'app-show-integration',
  imports: [],
  templateUrl: './show-integration.component.html',
  styleUrl: './show-integration.component.css'
})
export class ShowIntegrationComponent {

}
